<rt-admins-avatars
  [admins]="$any(admins)"
  [editable]="true"
  (addClick)="editAdmins()"
  (avatarsClick)="editAdmins()"
  variant="rtl"
></rt-admins-avatars>
